import { Box } from '@mui/joy';
import { ICellEditorParams } from 'ag-grid-enterprise';

import { Autocomplete, IAutocompleteProps } from 'core/components';
import { IAutocompleteOption } from 'core/types';

interface IProps extends ICellEditorParams {
  onValueChange: (value: unknown) => void;
  autocompleteProps?: IAutocompleteProps;
  getValueFromOption?: (option: IAutocompleteOption | null) => unknown;
}

export const AutocompleteCellEditor = ({
  value,
  stopEditing,
  onValueChange,
  autocompleteProps,
  getValueFromOption,
}: IProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        name="autocompleteCellEditor"
        value={value}
        onChange={(_, option) => {
          if (!option) {
            onValueChange(null);
            stopEditing();

            return;
          }

          onValueChange(getValueFromOption ? getValueFromOption(option) : option);

          stopEditing();
        }}
        {...autocompleteProps}
        listboxStyle={{ gap: 0 }}
        wrapperStyle={{ width: '100%' }}
      />
    </Box>
  );
};
